import { Heading, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface ProductsCodeListProps {
  codes?: string[];
}

export function ProductsCodeList({
  codes,
}: ProductsCodeListProps): JSX.Element {
  return (
    <S.Wrapper>
      <Heading size={FontSize.font24} weight={FontWeight.bold}>
        Lista de pedidos
      </Heading>

      {codes?.map((code) => (
        <Text size={FontSize.font18} key={code}>
          {code.toUpperCase()}
        </Text>
      ))}
    </S.Wrapper>
  );
}
